export default __webpack_public_path__ + "dist/media/Upload-second.2ada9a30.svg";